import React, {
    FormEvent,
    ReactElement,
    useEffect,
    useRef,
    useState,
} from "react";
import ButtonArrow from "../buttonArrow";
import ListingFilters from "@components/shared/listingFilters";
import { useDomainContext } from "@hooks/useDomainContext";
import { useRouter } from "next/router";
import { gettingQueriesAsString } from "@lib/shared/routerQueriesToString";
import styles from "./styles.module.scss";
import { questions } from "@components/shared/listingFilters/questions";
import { useModal } from "@hooks/useModalContext";

import { arrayToKeyedObject, base64EncodeUnicode } from "@lib/sharedUtils";

export default function SellingForm(): ReactElement {
    const { modal, initiateQuestions } = useModal();
    const [error, setError] = useState(false);

    const router = useRouter();
    const { category } = useDomainContext();

    const hiddenInputRef = useRef<HTMLInputElement | null>(null);

    const { questions: filters } = modal.listing;

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const gettingFilters = () => {
            const finalFilters: { [x: string]: string } = {};

            Object.keys(filters).forEach((filterKey) => {
                const filter = filters[filterKey] as
                    | { value?: string; name?: string }
                    | undefined;
                const value = filter?.value;
                const name = filter?.name;

                if (!value || !name) {
                    return;
                }

                finalFilters[name] = value;
            });

            return base64EncodeUnicode(JSON.stringify(finalFilters));
        };

        const zipCodeFilter = filters["zipCode"] as
            | { value?: string }
            | undefined;
        const zipCodeValue = zipCodeFilter?.value ?? "";

        if (zipCodeValue.length >= 4) {
            hiddenInputRef.current?.focus();
            const formattedZipCode =
                zipCodeValue.length === 4 ? `0${zipCodeValue}` : zipCodeValue;

            window.location.href = `${window.location.origin}/${
                category?.slugAlias ?? ""
            }/offers?zc=${formattedZipCode}&filters=${gettingFilters()}&referrer=${
                category?.slugAlias ?? ""
            }&${gettingQueriesAsString(router.query, "inline", ["category"])}`;
        } else {
            setError(true);
        }
    };

    useEffect(() => {
        initiateQuestions(
            arrayToKeyedObject(
                questions[category?.slugAlias as "auto"].filter(
                    (question) => question.isInHomePage,
                ) as [],
                "name",
            ),
        );
        setTimeout(() => {
            document.getElementsByName("zipCode")[0]?.focus();
        }, 100);
    }, [category]);

    return (
        <>
            <form className={styles["form"]} onSubmit={handleSubmit}>
                <ListingFilters
                    isQuestionSameRow={true}
                    noMinimize
                    className={styles["filters"]}
                    selectQuestionClassName={styles["select-question"]}
                    toggleQuestionClassName={styles["toggle-question"]}
                    textQuestionClassName={styles["text-question"]}
                />

                <div>
                    <button
                        type="submit"
                        name="zipCodeSubmit"
                        id="zipCodeSubmit"
                        className={`${styles["submit-button"]} py-1.5 px-3 rounded md:py-2.5 md:px-8 md:text-lg`}
                    >
                        <span>Get Started</span>
                        <ButtonArrow />
                    </button>
                </div>

                {error && (
                    <span className={styles["error"]}>
                        Please enter a valid zip code
                    </span>
                )}
            </form>
            <div>
                <input
                    type="number"
                    ref={hiddenInputRef}
                    className="select-none opacity-0 absolute -top-48 pointer-events-none"
                    autoComplete="off"
                />
            </div>
        </>
    );
}
